import { render, staticRenderFns } from "./CancledTab.vue?vue&type=template&id=620cf896"
import script from "./CancledTab.vue?vue&type=script&lang=js"
export * from "./CancledTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports